import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
let BigButton = class BigButton extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "className", void 0);
    _defineProperty(this, "icon", void 0);
    _defineProperty(this, "label", void 0);
  }
};
__decorate([Prop({
  default: ""
})], BigButton.prototype, "className", void 0);
__decorate([Prop({
  default: ""
})], BigButton.prototype, "icon", void 0);
__decorate([Prop({
  default: ""
})], BigButton.prototype, "label", void 0);
BigButton = __decorate([Component({
  components: {
    Icon
  }
})], BigButton);
export default BigButton;